import React from "react";
import PropTypes from "prop-types";

import Checkbox from "../shared/Checkbox";
import APlusDialog from "../shared/dialogs/APlusDialog";

class RelatedThemesFilterBox extends React.Component {
  static propTypes = {
    filterables: PropTypes.array.isRequired,
    header: PropTypes.string.isRequired,
    isPromoVisible: PropTypes.bool.isRequired,
    isSubscribed: PropTypes.bool.isRequired,
    onChange: PropTypes.func,
    showSidebarPromo: PropTypes.func.isRequired,
    totalFilters: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);

    this.onCheckboxChange = (e) => {
      if (!props.isSubscribed) {
        e.preventDefault();
        props.showSidebarPromo();
        return;
      }

      const { target } = e;

      if (target.checked) {
        this.setState((prev) => ({
          selected: prev.selected.concat([target.value])
        }));
      } else {
        this.setState((prev) => ({
          selected: prev.selected.filter((s) => s !== target.value)
        }));
      }
    };

    this.onMoreToggleClick = (_e) => {
      if (!props.isSubscribed) {
        props.showSidebarPromo();
        return;
      }

      this.setState((prev) => ({ allVisible: !prev.allVisible }));
    };

    this.state = {
      allVisible: false,
      selected: []
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selected.length !== prevState.selected.length &&
      this.props.onChange
    ) {
      this.props.onChange(this.state.selected);
    }
  }

  renderMoreToggleBtn() {
    const { allVisible } = this.state;
    const { header, totalFilters } = this.props;

    if (totalFilters <= 5) {
      return null;
    }

    return (
      <button
        type="button"
        className="btn btn-borderless btn-text btn-xs related-themes__show-more-less"
        onClick={this.onMoreToggleClick}
      >
        {`See ${allVisible ? "less" : "more"} ${header.toLowerCase()}s`}
      </button>
    );
  }

  render() {
    const { allVisible } = this.state;
    const { header, isPromoVisible, totalFilters } = this.props;
    let { filterables } = this.props;

    if (!allVisible) {
      filterables = filterables.slice(0, 5);
    }

    return (
      <div className="filter-box" style={{ position: "relative" }}>
        {isPromoVisible && <div className="overlay" style={{ zIndex: "1" }} />}
        <div className="header lit-guides">
          {header} ({totalFilters})
        </div>
        <ul className="list list_checkbox">
          {filterables.map((f) => (
            <li className="list__item" key={f.label}>
              <Checkbox
                label={`${f.label} (${f.count})`}
                name={`filter_checkbox_${f.label
                  .toLowerCase()
                  .replace(/\W/g, "-")}`}
                onChange={this.onCheckboxChange}
                value={f.label}
              />
            </li>
          ))}
        </ul>
        {this.renderMoreToggleBtn()}
      </div>
    );
  }
}

export default class RelatedThemes extends React.Component {
  static propTypes = {
    aPlusDialogContent: PropTypes.string.isRequired,
    aPlusDialogHref: PropTypes.string.isRequired,
    aPlusDialogLogoSrc: PropTypes.string.isRequired,
    blurredThemesImgSrc: PropTypes.string,
    filterableAuthorCount: PropTypes.number.isRequired,
    filterableAuthors: PropTypes.array.isRequired,
    filterableBookCount: PropTypes.number.isRequired,
    filterableBooks: PropTypes.array.isRequired,
    isFreeTier: PropTypes.bool.isRequired,
    isSubscribed: PropTypes.bool.isRequired,
    mainTheme: PropTypes.object.isRequired,
    relatedThemes: PropTypes.array.isRequired,
    relatedThemesCount: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);

    this.closeSidebarPromo = (_e) => {
      this.setState({ sidebarPromoVisible: false });
    };

    this.showSidebarPromo = () => {
      this.setState({ sidebarPromoVisible: true });
    };

    this.state = {
      filteredAuthors: [],
      filteredBooks: [],
      filteredThemes: props.relatedThemes,
      sidebarPromoVisible: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { filteredAuthors, filteredBooks } = this.state;
    if (
      filteredAuthors.length !== prevState.filteredAuthors.length ||
      filteredBooks.length !== prevState.filteredBooks.length
    ) {
      let filteredThemes = [];
      if (filteredAuthors.length || filteredBooks.length) {
        const a = this.selectedFiltersToHash(filteredAuthors);
        const b = this.selectedFiltersToHash(filteredBooks);
        filteredThemes = this.props.relatedThemes.filter(
          (t) => a[t.bookAuthorFullName] || b[t.bookTitle]
        );
      } else {
        filteredThemes = this.props.relatedThemes;
      }
      this.setState({ filteredThemes });
    }
  }

  selectedFiltersToHash(selected) {
    return selected.reduce((acc, k) => ({ ...acc, [k]: true }), {});
  }

  renderFilterBox({ filterables, header, key, totalFilters }) {
    const { aPlusDialogHref, aPlusDialogLogoSrc, isSubscribed } = this.props;

    return (
      <RelatedThemesFilterBox
        aPlusDialogHref={aPlusDialogHref}
        aPlusDialogLogoSrc={aPlusDialogLogoSrc}
        filterables={filterables}
        header={header}
        isPromoVisible={this.state.sidebarPromoVisible}
        isSubscribed={isSubscribed}
        onChange={(selected) => this.setState({ [key]: selected })}
        showSidebarPromo={this.showSidebarPromo}
        totalFilters={totalFilters}
      />
    );
  }

  renderSidebarPromo() {
    if (!this.state.sidebarPromoVisible) {
      return null;
    }

    const { aPlusDialogHref, aPlusDialogLogoSrc, isFreeTier } = this.props;

    return (
      <div className="a-plus-dialog" id="refinement-promo">
        <APlusDialog
          isFreeTier={isFreeTier}
          content="Update to refine your search."
          href={aPlusDialogHref}
          amplitudeKey="litRelatedThemesFilterSignUp"
          logoSrc={aPlusDialogLogoSrc}
          handleClose={this.closeSidebarPromo}
          shouldRenderCloseBtn
        />
      </div>
    );
  }

  renderSidebar() {
    const {
      filterableAuthorCount,
      filterableAuthors,
      filterableBookCount,
      filterableBooks
    } = this.props;
    return (
      <div className="sidebar">
        <div className="sidebar__header">
          <div className="sidebar__title">Refine Your Search by...</div>
        </div>
        {this.renderFilterBox({
          filterables: filterableBooks,
          header: "Book Title",
          key: "filteredBooks",
          totalFilters: filterableBookCount
        })}
        {this.renderFilterBox({
          filterables: filterableAuthors,
          header: "Author",
          key: "filteredAuthors",
          totalFilters: filterableAuthorCount
        })}
        {this.renderSidebarPromo()}
      </div>
    );
  }

  renderThemeYouWereReading() {
    const { mainTheme } = this.props;

    return (
      <div id="theme-you-were-reading" className="theme-box">
        <div className="theme-box__header">
          <div className="theme-box__title">Theme You Were Reading</div>
        </div>
        <div className="card card_theme">
          <div className="card-theme-col">
            <a
              href={mainTheme.path}
              className="card__icon"
              aria-label={`${mainTheme.title} theme icon`}
            >
              <span
                className="sm:tw-hidden"
                dangerouslySetInnerHTML={{ __html: mainTheme.mediumIconHtml }}
              />
              <span
                className="tw-hidden sm:tw-block"
                dangerouslySetInnerHTML={{ __html: mainTheme.largeIconHtml }}
              />
            </a>
          </div>
          <div className="card-theme-col">
            <div className="card__title">
              <a href={mainTheme.path} className="theme-title link">
                {mainTheme.title}
              </a>{" "}
              in{" "}
              <a href={mainTheme.bookPath} className="link">
                {mainTheme.bookTitle}
              </a>{" "}
              by {mainTheme.bookAuthorFullName}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderRelatedThemeCards() {
    if (!this.props.isSubscribed) {
      return null;
    }

    const { filteredThemes } = this.state;

    return filteredThemes.map((t) => (
      <div className="theme-box" key={t.path}>
        <div className="card card_theme">
          <div className="card-theme-col">
            <a
              href={t.path}
              className="card__icon"
              aria-label={`${t.title} theme icon`}
            >
              <span
                className="sm:tw-hidden"
                dangerouslySetInnerHTML={{ __html: t.mediumIconHtml }}
              />
              <span
                className="tw-hidden sm:tw-block"
                dangerouslySetInnerHTML={{ __html: t.largeIconHtml }}
              />
            </a>
          </div>
          <div className="card-theme-col">
            <div className="card__title">
              <a href={t.path} className="theme-title link">
                {t.title}
              </a>{" "}
              in{" "}
              <a href={t.bookPath} className="link">
                {t.bookTitle}
              </a>{" "}
              by {t.bookAuthorFullName}
            </div>
            <p
              className="card__description no-inline-characters no-inline-symbols no-inline-terms"
              dangerouslySetInnerHTML={{ __html: t.descriptionHtml }}
            />
            <div className="read-full">
              <a href={t.path} className="link">
                Read analysis of {t.title}
              </a>
            </div>
          </div>
        </div>
      </div>
    ));
  }

  renderRelatedThemesBlur() {
    if (this.props.isSubscribed) {
      return null;
    }

    const { blurredThemesImgSrc } = this.props;

    return (
      <div>
        <img src={blurredThemesImgSrc} alt="" style={{ maxWidth: "100%" }} />
        <img src={blurredThemesImgSrc} alt="" style={{ maxWidth: "100%" }} />
      </div>
    );
  }

  renderPromo() {
    if (this.props.isSubscribed) {
      return null;
    }

    const { aPlusDialogContent, aPlusDialogHref, aPlusDialogLogoSrc } =
      this.props;

    return (
      <div>
        <APlusDialog
          content={aPlusDialogContent}
          href={aPlusDialogHref}
          amplitudeKey="litRelatedThemesCentralColumnSignUp"
          logoSrc={aPlusDialogLogoSrc}
        />
      </div>
    );
  }

  getThemeCount() {
    const { relatedThemes, relatedThemesCount } = this.props;
    const { filteredThemes } = this.state;
    // no relatedThemes are passed unless user is subscribed
    return relatedThemes.length ? filteredThemes.length : relatedThemesCount;
  }

  renderRelatedThemes() {
    return (
      <div className="closed-box">
        <div className="closed-box__container" id="related_themes">
          <div className="theme">
            <div className="theme-box__header">
              <div className="theme-box__title">
                <span id="related-theme-count">{this.getThemeCount()}</span>{" "}
                Related Themes from Other Texts
              </div>
              <div className="theme-box__subtitle">
                Themes are ordered from most to least related.
              </div>
            </div>
            <div className="related-themes">
              {this.renderRelatedThemeCards()}
              {this.renderRelatedThemesBlur()}
              {this.renderPromo()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="related">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-4">{this.renderSidebar()}</div>
            <div className="col-xs-12 col-sm-8">
              {this.renderThemeYouWereReading()}
              {this.renderRelatedThemes()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
